import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { EmployeeLoanComponent } from '../employee-loan/employee-loan.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-employee-loan-list',
  templateUrl: './employee-loan-list.component.html',
  styleUrls: ['./employee-loan-list.component.css']
})
export class EmployeeLoanListComponent implements OnInit {

  public menu_item_id = '46';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['employee_no', 'name', 'type', 'amount', 'is_paid', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<EmployeeLoanComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'employee_no': '', 'name': '' };

  Success_Msg; Error_Msg; Del_Msg; Cust; Loan; Paid; Unpaid;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Cust').subscribe((res: string) => {
      this.Cust = res;
    });

    translate.get('Paid').subscribe((res: string) => {
      this.Paid = res;
    });

    translate.get('Unpaid').subscribe((res: string) => {
      this.Unpaid = res;
    });

    translate.get('Loan').subscribe((res: string) => {
      this.Loan = res;
    });
  }


  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {

    let condition = "";

    if (this.model['employee_no'] != '')
      condition += " AND `employee`.`employee_no` LIKE '%" + this.model['employee_no'] + "%' ";

    if (this.model['name'] != '')
      condition += " AND (`employee`.`name` LIKE '%" + this.model['name'] +
        "%' OR `employee`.`name_en` LIKE '%" + this.model['name'] + "%') ";

    let query = "SELECT `emp_loan`.* , `employee`.`employee_id`, `employee`.`name`, `employee`.`employee_no` FROM `emp_loan`, `employee`" +
      " WHERE `employee`.`employee_no` = `emp_loan`.`employee_no` AND `emp_loan`.`status` = '1'" + condition;
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        data.data['list'].forEach(element => {
          if (element.type == 'loan')
            element.type = this.Loan;
          else if (element.type == 'custody')
            element.type = this.Cust;

          if (element.is_paid == '0')
            element.is_paid = this.Paid;
          else if (element.is_paid == '1')
            element.is_paid = this.Unpaid;

        });
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });


  }

  newLoan() {
    this.addDialogRef = this.dialog.open(EmployeeLoanComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
      });
  }

  /* editLoan(row){
 
 
   }
 
   delLoan(row) {
     if (confirm("نتيجة الحذف قد تؤثر على بيانات أخرى، هل أنت متأكد من رغبتك بالاستمرار؟")) {
       let values = [{ 'table_name': this.model['table_name'], 'emp_loan_id': row.emp_loan_id }];
       let obj = { cmd: 'deleteRec', values: values };
 
       this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
         .subscribe(data => {
           this.applicationConstants.appComp.hideBusyCursor();
           if (data.status['type'] == 'success') {
             alert(" تمت العملية بنجاح ");
             this.search();
           }
           else {
             alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
           }
         });
     }
   }*/

}
